/**
 * ONE Account UI API
 * Rest API definition for ONE Account UI. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: toannhanb7@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KeyCloakUser { 
    id?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    avatar?: string;
    title?: string;
    username?: string;
    email?: string;
}

